import type { BillableActionType } from "@/constants/credit";

const EP_URL = "/analiza-efect-perturbator";
const IR_URL = "/identificare-raportare";
const EVM_URL = "/evaluare-maturitate";
const PR_URL = "/plan-remediere";

export function buildRiskAnalysisUrl(sessionId?: string | null): string {
  return sessionId ? `/analiza-risc/${sessionId}` : "/analiza-risc";
}

const PAYWALL_REDIRECT_MAP: Partial<
  Record<BillableActionType, (sessionId?: string | null) => string>
> = {
  // DNSC flat actions
  notificare_initiala_dnsc: () => IR_URL,
  doc_notificare_dnsc_pdf: () => IR_URL,
  evidenta_decizie_inregistrare_dnsc: () => IR_URL,

  // Efect Perturbator (flat)
  analiza_efect_perturbator: () => EP_URL,
  doc_analiza_efect_perturbator_pdf: () => EP_URL,

  // ENIRE risk (flat) — session-scoped deep link
  evaluare_risc_enire: buildRiskAnalysisUrl,
  doc_analiza_risc_enire_pdf: buildRiskAnalysisUrl,

  // Maturity (matrix)
  chestionar_preliminar_v2: () => EVM_URL,
  calcul_maturitate_v2: () => EVM_URL,
  eval_maturitate_ai_asistata: () => EVM_URL,
  s3_raport_pdf_v2: () => EVM_URL,

  // Plan Remediere (matrix)
  plan_remediere_v2: () => PR_URL,
  doc_plan_remediere_pdf: () => PR_URL,
};

const ALLOWED_REDIRECT_PREFIXES = [
  IR_URL,
  "/analiza-risc",
  EP_URL,
  EVM_URL,
  PR_URL,
  "/profil",
];

export function getRedirectUrlForAction(
  actionType: BillableActionType,
  sessionId?: string | null
): string {
  const builder = PAYWALL_REDIRECT_MAP[actionType];
  return builder ? builder(sessionId) : IR_URL;
}

export function isValidRedirectUrl(url: string): boolean {
  if (!url.startsWith("/")) return false;
  return ALLOWED_REDIRECT_PREFIXES.some(
    (prefix) => url === prefix || url.startsWith(`${prefix}/`)
  );
}
